import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CustomerOrderStatus } from 'src/app/Enums/order';
import { CustomerOrderDetail, OrderStatusVM, ProductWarrantyItem, UpdateDeliveryPriceVM } from 'src/app/models/customer/customer.model';
import { ProductResponseModel } from 'src/app/models/Home/home-list.model';
import { GetProductAssetModel } from 'src/app/models/product/productAssets.modal';
import { ProductWarrantyDescriptionComponent } from 'src/app/modules/layoutShopModule/shop-components/product-warranty-description/product-warranty-description.component';
import { AdminOrderListService } from 'src/app/services/admin-order-list.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { CustomerService } from 'src/app/services/customer.service';
import { HomePageService } from 'src/app/services/home-page.service';

@Component({
  selector: 'app-admin-single-order-list',
  templateUrl: './admin-single-order-list.component.html',
  styleUrls: ['./admin-single-order-list.component.css']
})
export class AdminSingleOrderListComponent implements OnInit {

  Loader: boolean = false;
  adminOrdersVM: CustomerOrderDetail = new CustomerOrderDetail();
  productAssets: GetProductAssetModel = new GetProductAssetModel();
  id: number;
  productId: number;
  productImageResponseModel: Array<GetProductAssetModel> = new Array<GetProductAssetModel>();
  showImageinMainFrame: GetProductAssetModel = new GetProductAssetModel();
  homeProductResponseModel: ProductResponseModel = new ProductResponseModel();
  orderStatus: OrderStatusVM = new OrderStatusVM();
  deliveryPriceUpdate: UpdateDeliveryPriceVM = new UpdateDeliveryPriceVM();
  CustomerOrderStatus: typeof CustomerOrderStatus = CustomerOrderStatus;
  customerOrderStatusArray: Array<string>; 
  LoaderStatus: boolean = false;
  isDiscount: boolean = true;
  adminWarrantyItem: ProductWarrantyItem = new ProductWarrantyItem();
  ProducrId: number;
  warrantyYearPrice1: string;
  warrantyYearPrice2: string
  warrantyId: string;
  warrantyDatiles: CustomerOrderDetail = new CustomerOrderDetail();
  ProductIdsImage: number;
  warrantyYearPlan: string;
  newwareentyPlan: string;
  localStorageService: LocalstorageService;
  customerDeliveryPrice: string;
  orderTrackingNumber: string;
  price: boolean = false;
  displayPrice: boolean = false;
  deliveryPriceVisibility: boolean = true;
  addDeliveryPriceVisibility: boolean = false;

  constructor(private _localStorageService: LocalstorageService,private _adminOrderListService: AdminOrderListService, private _customerService: CustomerService, private modalService: NgbModal, private homePageService: HomePageService, private alertify: AlertifyService, private route: ActivatedRoute, private router: Router, private fb: FormBuilder) {
    this.localStorageService = _localStorageService;
   }

  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.id = +param.id
      this.productId = +param.productId
    })
    var customerStatusValues = new Array<string>();  
    Object.values(CustomerOrderStatus).map(function(key){       
      if (typeof(key) == 'string') {
        customerStatusValues.push(key);
      }  
    });
    this.customerOrderStatusArray = customerStatusValues;
    this.customerOrderStatusArray = customerStatusValues; 
    if (this.localStorageService.getToken()) {
      this.getOrdersDetail();
    } else {
      this.router.navigate(['/login'], { queryParams: { return: window.location.href } });
    }
  }

  getOrdersDetail() {
    this.Loader = true;
    this.adminOrdersVM.id = this.id;
    this._adminOrderListService.getAdminOrderDetail(this.adminOrdersVM.id)
      .subscribe((response) => {
        this.Loader = false;
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.adminOrdersVM = responseBody.responseData;
          this.customerDeliveryPrice = this.adminOrdersVM.deliveryPrice;
          this.orderTrackingNumber = this.adminOrdersVM.trackingNumber;
          this.warrantyDatiles = this.adminOrdersVM;
          this.warrantyId = this.adminOrdersVM.warrantyId;
          this.warrantyYearPlan = this.adminOrdersVM.warrantyYear;
          if(this.warrantyYearPlan >= "1"){
            this.newwareentyPlan = this.warrantyYearPlan;
           }
          this.ProductIdsImage = this.adminOrdersVM.productId;
          if(this.warrantyId){
          var durationWithPrizeList = JSON.parse(this.adminOrdersVM.warrantyPrice);
          for (var i = 0; i < durationWithPrizeList.length; i++) {
            if (durationWithPrizeList[i].Duration == this.adminOrdersVM.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.adminOrdersVM.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.adminOrdersVM.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.adminOrdersVM.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            }
            else if (durationWithPrizeList[i].Duration == this.adminOrdersVM.warrantyYear) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } 
            if(this.adminOrdersVM.applicationInstallationPrice == '1') {
              this.warrantyYearPrice2 = durationWithPrizeList[i].Price;
            }
          }
        }
          
          if(this.adminOrdersVM.discount == 0) {
            this.isDiscount = false;
          }
          this.productSingleImage(this.adminOrdersVM);
          this.Loader = false;
        }
        else {
          this.alertify.error(responseBody.responseMessage)
          return;
        }
      },
        (err) => {
        });
  }

  productSingleImage(adminOrdersVM) {
    this.Loader = true;
    var productId = adminOrdersVM.productId;
    this.homePageService.ProductImageList(productId)
      .subscribe((response) => {
        this.Loader = false;
        let responseimage = JSON.parse(response._body)
        if (responseimage.isSuccess) {
          this.homeProductResponseModel.ProductSort = responseimage.responseData;
        } (err) => {
        }
      })
  }

  cancelButton() {
    this.router.navigate(['/admin-order-list']);
  }

  selectActive(selectedValue) {
    this.orderStatus.OrderStatus = selectedValue;
  }

  updateStatus() {
    this.LoaderStatus = true;
    this.orderStatus.id = this.id;
    this._adminOrderListService.adminUpdateStatus(this.orderStatus)
      .subscribe(response => {
        this.LoaderStatus = false;
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.adminOrdersVM = responseBody.responseData;
          this.alertify.success(responseBody.responseMessage);
        } (err) => {
        }
      });
  }

  productImage(){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + this.ProductIdsImage]));
      window.open('#' + url, '_blank');
  }

  ProductWarrantyDetails(ProductWarrantyDetails) {
    localStorage.setItem('ProductId', this.id.toString());
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this._customerService.passId(ProductWarrantyDetails.id);
    let modalRef = this.modalService.open(ProductWarrantyDescriptionComponent, modalConfig);
  }

  invoice() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/customer-download-invoice/' + this.id]));
      window.open('#' + url, '_blank');  
 }

 editDeliveryPrice() {
  this.displayPrice = true;
  this.deliveryPriceVisibility = false;
 }

 updateDeliveryPrice() {
  if (this.deliveryPriceUpdate.DeliveryPrice == undefined || this.deliveryPriceUpdate.DeliveryPrice == null || this.deliveryPriceUpdate.DeliveryPrice == "") {
    this.alertify.error("Delivery Price is required");
    return;
  }
  var deliveryPriceIsNum = Number.isNaN(Number(this.deliveryPriceUpdate.DeliveryPrice));
  if (deliveryPriceIsNum == true) {
    this.alertify.error("Delivery Price is not a amount");
    return;
  }
  this.LoaderStatus = true;
  this.deliveryPriceUpdate.Id = this.id;
  this._adminOrderListService.adminDeliveryPriceUpdate(this.deliveryPriceUpdate)
  .subscribe(response => {
    this.LoaderStatus = false;
    var responseBody = JSON.parse(response._body);
    if (responseBody.isSuccess) {
      this.getOrdersDetail();
      this.displayPrice = false;
      this.deliveryPriceVisibility =true;
      this.adminOrdersVM = responseBody.responseData;
      this.alertify.success(responseBody.responseMessage);
    } (err) => {
    }
  });
 }

 addDeliveryPrice() {
  this.addDeliveryPriceVisibility = true;
  this.deliveryPriceVisibility =true;
 }
}
